/* Dropdayz — De Vitrine (Luxury).

   Derde bewegende hero, naast De Stapel (sneakers) en De Rail (kleding).
   Luxury vroeg om een ander ritme: geen vallende dozen of doorschuivend
   rek, maar de rust van een etalage. Een smalle lichtbundel strijkt heel
   traag over een rij tassen op een plint; de tas die in het licht staat
   licht blauw op, tilt een paar pixels en zakt weer terug zodra het licht
   verder is. Eén volledige sweep duurt 14 seconden — bewust langzaam, want
   snelheid en luxe gaan niet samen.

   Zelfde contract als de andere twee (ddz-hero-motion.js):
   - geen libraries, geen afbeeldingen
   - rAF loopt alleen als de hero >= 10% in beeld is EN de tab actief is
   - dt geklemd op 0.033 zodat een trage frame geen sprong geeft
   - devicePixelRatio begrensd op 2
   - prefers-reduced-motion: één stilstaand frame, met het licht op de
     middelste tas zodat het beeld ook stil betekenis heeft

   MOBIEL (< 700px): drie tassen in plaats van vijf, kleiner geschaald, en
   de plint ligt hoger zodat de kop en de statblokken vrij blijven.

   De tasvormen zijn met opzet silhouetten: een tote met twee hengsels en
   een mini-bag met schouderketting. Geen merklogo's — die horen op de
   producten, niet in de decoratie.
*/
(function () {
  'use strict';
  var rm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SWEEP = 14;   /* seconden voor één volledige lichtbeweging */

  function tekenTote(g, s, licht) {
    /* tote: trapezium met twee hengsels */
    var B = 78 * s, Hh = 62 * s;
    g.lineWidth = 2.2;
    g.strokeStyle = licht ? '#30a8e0' : 'rgba(255,255,255,.72)';
    g.fillStyle = licht ? 'rgba(48,168,224,.14)' : 'rgba(255,255,255,.04)';
    g.beginPath();
    g.moveTo(-B / 2, -Hh); g.lineTo(B / 2, -Hh);
    g.lineTo(B / 2 - 7 * s, 0); g.lineTo(-B / 2 + 7 * s, 0);
    g.closePath(); g.fill(); g.stroke();
    /* hengsels */
    g.beginPath();
    g.moveTo(-B / 4, -Hh); g.bezierCurveTo(-B / 4, -Hh - 26 * s, -B / 22, -Hh - 26 * s, -B / 22, -Hh);
    g.moveTo(B / 22, -Hh); g.bezierCurveTo(B / 22, -Hh - 26 * s, B / 4, -Hh - 26 * s, B / 4, -Hh);
    g.stroke();
    /* sluiting */
    g.fillStyle = licht ? '#30a8e0' : 'rgba(255,255,255,.5)';
    g.fillRect(-4 * s, -Hh + 12 * s, 8 * s, 5 * s);
  }

  function tekenMini(g, s, licht) {
    /* mini-bag met flap en schouderketting */
    var B = 54 * s, Hh = 40 * s;
    g.lineWidth = 2.2;
    g.strokeStyle = licht ? '#30a8e0' : 'rgba(255,255,255,.72)';
    g.fillStyle = licht ? 'rgba(48,168,224,.14)' : 'rgba(255,255,255,.04)';
    g.beginPath();
    if (g.roundRect) { g.roundRect(-B / 2, -Hh, B, Hh, 4 * s); }
    else { g.rect(-B / 2, -Hh, B, Hh); }
    g.fill(); g.stroke();
    /* flap */
    g.beginPath();
    g.moveTo(-B / 2, -Hh + 15 * s); g.lineTo(B / 2, -Hh + 15 * s); g.stroke();
    /* ketting */
    g.beginPath();
    g.moveTo(-B / 2 + 5 * s, -Hh);
    g.bezierCurveTo(-B / 2 - 4 * s, -Hh - 34 * s, B / 2 + 4 * s, -Hh - 34 * s, B / 2 - 5 * s, -Hh);
    g.stroke();
    g.fillStyle = licht ? '#30a8e0' : 'rgba(255,255,255,.5)';
    g.beginPath(); g.arc(0, -Hh + 15 * s, 3.4 * s, 0, 6.3); g.fill();
  }

  function init() { return { }; }

  function draw(g, w, h, t, dt, s) {
    g.clearRect(0, 0, w, h);
    var mob = w < 700;
    var schaal = mob ? .66 : Math.min(1.05, w / 1150);
    var aantal = mob ? 3 : 5;
    var plint = mob ? h * .52 : h - 54;

    /* plint */
    var grad = g.createLinearGradient(0, 0, w, 0);
    grad.addColorStop(0, 'rgba(255,255,255,0)');
    grad.addColorStop(.5, 'rgba(255,255,255,.22)');
    grad.addColorStop(1, 'rgba(255,255,255,0)');
    g.strokeStyle = grad; g.lineWidth = 1.5;
    g.beginPath(); g.moveTo(0, plint + .5); g.lineTo(w, plint + .5); g.stroke();

    /* posities: rechterhelft op desktop, gecentreerd op mobiel */
    var vanaf = mob ? w * .10 : w * .42;
    var tot = w * .94;
    var stap = (tot - vanaf) / (aantal - 1);

    /* lichtpositie: heen en weer, met een rustpauze aan beide kanten */
    var fase = rm ? .5 : (t % SWEEP) / SWEEP;
    var p = fase < .5 ? fase * 2 : (1 - fase) * 2;
    p = p * p * (3 - 2 * p);                    /* smoothstep: traag aan de randen */
    var lichtX = vanaf - stap * .4 + p * (tot - vanaf + stap * .8);

    /* lichtbundel */
    if (!rm) {
      var bundel = g.createRadialGradient(lichtX, plint - 70 * schaal, 0, lichtX, plint - 70 * schaal, 170 * schaal);
      bundel.addColorStop(0, 'rgba(48,168,224,.16)');
      bundel.addColorStop(1, 'rgba(48,168,224,0)');
      g.fillStyle = bundel;
      g.fillRect(0, 0, w, h);
    }

    for (var i = 0; i < aantal; i++) {
      var x = vanaf + i * stap;
      var afstand = Math.abs(x - lichtX) / (stap * .62);
      var intensiteit = Math.max(0, 1 - afstand);
      var licht = intensiteit > .45;
      var lift = intensiteit * 9 * schaal;

      g.save();
      g.translate(x, plint - lift);

      /* spiegeling op de plint */
      g.save();
      g.globalAlpha = .13 + intensiteit * .1;
      g.scale(1, -.42);
      g.translate(0, -2);
      if (i % 2 === 0) tekenTote(g, schaal, licht); else tekenMini(g, schaal, licht);
      g.restore();

      if (licht) { g.shadowColor = 'rgba(48,168,224,.5)'; g.shadowBlur = 22 * intensiteit; }
      if (i % 2 === 0) tekenTote(g, schaal, licht); else tekenMini(g, schaal, licht);
      g.restore();
    }
  }

  /* zelfde starter als ddz-hero-motion.js */
  function start(canvas) {
    var ctx = canvas.getContext('2d');
    var W = 0, H = 0, zichtbaar = false, vorige = 0, staat = init();
    function maat() {
      var r = canvas.getBoundingClientRect();
      if (r.width < 2) return;
      var d = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = r.width * d; canvas.height = r.height * d;
      ctx.setTransform(d, 0, 0, d, 0, 0);
      W = r.width; H = r.height;
      if (rm) draw(ctx, W, H, 0, 0, staat);
    }
    maat();
    window.addEventListener('resize', maat);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { zichtbaar = e[0].isIntersecting; }, { threshold: .1 }).observe(canvas);
    } else { zichtbaar = true; }
    if (rm) return;
    requestAnimationFrame(function lus(now) {
      requestAnimationFrame(lus);
      if (!W) { maat(); return; }
      if (!zichtbaar || document.hidden) { vorige = now; return; }
      var dt = Math.min((now - vorige) / 1000, .033) || .016;
      vorige = now;
      draw(ctx, W, H, now / 1000, dt, staat);
    });
  }

  function op() {
    document.querySelectorAll('canvas[data-ddz-motion="vitrine"]').forEach(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', op);
  else op();
})();
